import React from 'react';
import { I18nextProvider } from 'react-i18next';
import az from './locales/az.json';
import ru from './locales/ru.json';
import { logout } from '../sharedNewEditAdPage/api';

document.addEventListener('DOMContentLoaded', async () => {
  const container: HTMLElement | null = document.getElementById('chat-link-app');

  if (!container) return;

  try {
    const { createRoot } = await import('react-dom/client');
    const { ChatLink } = await import('./components');
    const { AuthProvider } = await import('../chat/providers/AuthProvider');
    const { ChatProvider } = await import('../chat/providers/ChatProvider');
    const { SubscriptionsManager } = await import('../chat/subscriptions/SubscriptionsManager');
    const { customizeI18n } = await import('../utils/i18n');
    const { BrowserRouter } = await import('react-router-dom');
    const { ThemeProviderWrapper } =
      await import('@/styled/themes/ThemeProvider/ThemeProviderWrapper');

    const isUserSignedIn = container.dataset.userSignedIn === 'true';
    const isMobile = container.dataset.isMobile === 'true';
    const chatEnabled = container.dataset.chatEnabled === 'true';
    const internalId = container.dataset.internalId || undefined;

    const i18n = customizeI18n({ az, ru });

    createRoot(container).render(
      <BrowserRouter>
        <I18nextProvider {...{ i18n }}>
          <ThemeProviderWrapper>
            <AuthProvider
              userSignedIn={isUserSignedIn}
              projectLogout={logout}
              internalId={internalId}
            >
              <ChatProvider>
                <SubscriptionsManager exposeTestControls />
                <ChatLink
                  {...{ isUserSignedIn, isMobile, chatEnabled }}
                  backgroundColor="#fff"
                  projectMainColor="#ca1016"
                  projectTextColor="#8d94ad"
                />
              </ChatProvider>
            </AuthProvider>
          </ThemeProviderWrapper>
        </I18nextProvider>
      </BrowserRouter>
    );
  } catch (e) {
    console.error('Failed while initializing chat-link', e);
  }
});
